exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/main/content/DialogConfirmacion/dialogo-confirmacion.component.css
// module id = ../../../../../src/app/main/content/DialogConfirmacion/dialogo-confirmacion.component.css
// module chunks = main